import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { SchoolselectorService } from "../../../schoolselector/schoolselectorservice.service";
import { DataService_SubstituteMaintenance } from "../shared/data.service";
import { AddSubstitutePersonComponent } from "./add-substitute-person/add-substitute-person.component";
import { AddSubstitutionSwapComponent } from "./add-substitution-swap/add-substitution-swap.component";

@Component({
	selector: "caass-sub-main-table",
	templateUrl: "./sub-main-table.component.html",
	styleUrls: ["./sub-main-table.component.css"],
})
export class SubMainTableComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private SubstituteMaintenanceService: DataService_SubstituteMaintenance,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});

		// this.loadPerson();
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Output() PersonSelected: EventEmitter<any> = new EventEmitter();

	School: any;
	PersonTypeID: any = 17;
	lstPersonType: any = [
		{
			PersonTypeID: -1,
			PersonTypeDesc: "All",
		},
		{
			PersonTypeID: 17,
			PersonTypeDesc: "Substitute",
		},
	];

	IsSubbingToday: any = -1;
	lstSubbingToday: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Yes",
		},
		{
			ID: 0,
			Desc: "No",
		},
	];

	ActiveID: any = -1;
	lstActive = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	subscription: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPerson: any;
	lstPerson: any = [];

	//Filter lists
	lstSubbingForDesc: any = [];
	lstActiveDesc: any = [];
	lstPersonTypeDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "UserName", header: "Username(s)" },
		{ field: "SubbingForDesc", header: "Subbing For" },
		{ field: "PersonTypeDesc", header: "Person Type" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadPerson() {
		this.loading = true;

		var result = this.SubstituteMaintenanceService.SubstituteTableSelectList(this.School.SchoolID, this.PersonTypeID, this.IsSubbingToday, this.ActiveID);
		result.subscribe(
			(response) => {
				this.lstPerson = response;

				//Load Data Filter Lists
				// this.lstSubbingForDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.SubbingForDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ActiveDesc))).sort();
				this.lstPersonTypeDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.PersonTypeDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadPerson();
	}

	//Custom Button Methods
	onAddSubPerson() {
		this.errorMessage = "";

		var ref = this.dialogService.open(AddSubstitutePersonComponent, {
			header: "Create Sub Account",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SchoolID: this.School.SchoolID,
				SchoolName: this.School.SchoolName,
				SchoolNumber: this.School.SchoolNumber,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadPerson();
			}
		});
	}

	onAssignSub() {
		this.errorMessage = "";

		if (this.SelectedPerson == undefined) {
			this.errorMessage = "Select a person to set who they are subbing for";
			return;
		}

		let popup_SizeInt = window.innerWidth - 80;
		let popup_Size = popup_SizeInt.toString() + "px";

		var ref = this.dialogService.open(AddSubstitutionSwapComponent, {
			header: "Assign Substitute",
			// height: popup_Size,
			width: popup_Size,
			data: {
				//INSERT Custom Data here
				SelectedPerson: this.SelectedPerson,
				user: this.user,
				School: this.School,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadPerson();
			}
		});
	}

	onToggleSub() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedPerson == undefined) {
			this.errorMessage = "Select a person to toggle active or inactive";
			return;
		}

		if (this.SelectedPerson.PersonTypeID != 17) {
			this.errorMessage = "Please use the User Administration page under System Administration to deactivate accounts for normal staff members.";
			return;
		}

		//Confirm
		this.confirmationService.confirm({
			key: "main",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message:
				"This will activate or deactive all of the accounts associated with this person. If their accounts are deactivated they won't be able to log in. You can also use the System Admin/User Admin page to manage individual accounts. Do you want to continue?",
			header: "Confirm Toggle Substitute",
			icon: "fa",
			accept: () => {
				this.FinishToggle();
			},
			reject: () => {
				return;
			},
		});
		//Call SP
	}

	FinishToggle() {
		var changeTo = this.SelectedPerson.Active == 1 ? 0 : 1;

		var result = this.SubstituteMaintenanceService.SubstituteToggle(this.SelectedPerson.PersonID, changeTo);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadPerson();
				} else {
					var MSG = "Unable to ";

					if (changeTo == 1) {
						MSG += " activte ";
					} else {
						MSG += " deactivate ";
					}

					MSG += "this user's accounts";

					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
						reject: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onSchoolChange(val) {
		this.errorMessage = "";

		this.School = val;

		this.loadPerson();
	}

	onPersonTypeChange(val) {
		this.errorMessage = "";

		this.PersonTypeID = val;

		this.loadPerson();
	}

	onSubbingTodayChange(val) {
		this.errorMessage = "";

		this.IsSubbingToday = val;

		this.loadPerson();
	}

	onActiveChange(val) {
		this.errorMessage = "";

		this.ActiveID = val;

		this.loadPerson();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedPerson = val.data;

		this.PersonSelected.emit(this.SelectedPerson);
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedPerson = null;
		this.PersonSelected.emit(this.SelectedPerson);
	}
	onRowDblClick(Person) {
		this.errorMessage = "";

		this.SelectedPerson = Person;
		this.PersonSelected.emit(this.SelectedPerson);

		this.onAssignSub();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true;
	}

	////////////////////////////////////////////
}
